import axios from 'axios'

export default {
  list: async () => {
    const url = `/prediction/`;
    return await axios.get(url);
  },
}
